export default __webpack_public_path__ + "static/media/img3.edfa9a39.png";